import React, { useState } from 'react'
import { useMediaQuery } from '@mui/material'
// import { ChartsAppBar } from './ChartsAppBar'
import { PoolsTable } from './PoolsTable'
import { TokensTable } from './TokensTable'
import { TvlChart } from './TvlChart'
import { VolumeChart } from './VolumeChart'
import backgroundImage from '../../images/bgd/bg-mobile-new.png'
import { useStoreActions } from '../../model/hooks'
import { useEffect } from 'react'
import { GAtrack } from '../../services/ga'
import { useWalletContext } from '../WalletContext'
import { useParams } from 'react-router-dom'
import { PoolInfoPage } from './PoolInfoPage'
import { TotalChartsOverview, fetchTotalOverview } from './chartsApi'
import Header from '../Header/Header'
import Social from '../Social'
import Footer from '../Footer/Footer'

export enum CustomBreakpoints {
    XSmall = 0,
    Small = 450,
    Medium = 900,
    Large = 1100,
    extraLarge = 1280
}

export const useCustomBreakpoint = () => {
    const isSmall = useMediaQuery(`(min-width: ${CustomBreakpoints.Small}px)`)
    const isMedium = useMediaQuery(`(min-width: ${CustomBreakpoints.Medium}px)`)
    const isLarge = useMediaQuery(`(min-width: ${CustomBreakpoints.Large}px)`)
    const isExtraLarge = useMediaQuery(`(min-width: ${CustomBreakpoints.extraLarge}px)`)

    return isExtraLarge
        ? CustomBreakpoints.extraLarge
        : isLarge
        ? CustomBreakpoints.Large
        : isMedium
        ? CustomBreakpoints.Medium
        : isSmall
        ? CustomBreakpoints.Small
        : CustomBreakpoints.XSmall
}

export function Charts() {
    const { networkName: network } = useWalletContext()
    const { address } = useParams()
    const [overview, setOverview] = useState(undefined as unknown as TotalChartsOverview)
    const loadPrices = useStoreActions((actions) => actions.pricing.loadPrices)

    useEffect(() => {
        loadOverview()
    }, [])

    useEffect(() => {
        if (network === 'mainnet-alpha') GAtrack('route_charts', 'route_charts', 'charts', -1)

        loadTokensPricing()
        const intervalId = setInterval(() => {
            loadTokensPricing()
        }, 180000)

        return () => {
            clearInterval(intervalId)
        }
    }, [])

    async function loadOverview() {
        const overview = await fetchTotalOverview()
        setOverview(overview)
    }

    function loadTokensPricing() {
        loadPrices()
    }

    if (address) {
        return <PoolInfoPage selectedPoolLiquidity={address} key={'poolInfo'} />
    }

    function renderDesktopFooter() {
        return (
            // <div className='hidden lg:flex w-full justify-center z-[0] fixed bottom-[16px]'>
            //     <div className='container '>
            <div className='flex pb-[40px]'>
                <Social />
            </div>
            //     </div>
            // </div>
        )
    }
    return (
        <div
            className='h-full relative pb-[48px] lg:pb-0'
            style={{
                backgroundImage: `url(${backgroundImage})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat'
            }}>
            <div className='lg:pt-6 max-w-[98%] m-auto'>
                <Header selectedTab={'charts'} className={''} />
            </div>
            <div className='container mx-auto mt-[60px]'>
                {/* <ChartsAppBar /> */}
                <div className='flex w-full'>
                    <div className='w-full'>
                        {
                            <div className='flex flex-col p-4'>
                                <div className='w-full'>
                                    <div className='flex flex-col lg:flex-row mb-[50px]'>
                                        <div className='flex-1 max-h-[500px]'>
                                            <TvlChart overView={overview} className='' />
                                        </div>
                                        <div className='flex-1 max-h-[500px]  mt-[20px] lg:mt-0'>
                                            <VolumeChart overView={overview} className='ml-4' />
                                        </div>
                                    </div>
                                </div>

                                <PoolsTable />
                                <div className='my-4' />
                                <TokensTable />
                                {renderDesktopFooter()}
                            </div>
                        }
                        {/* {renderDesktopFooter()} */}
                    </div>
                </div>
            </div>
            <Footer isSocialDisabled={true} selectedTab='charts' />
        </div>
    )
}
